// Import core modules
import { DotLottie } from '@lottiefiles/dotlottie-web';
//import lottie from 'lottie-web';

import { gsap } from 'gsap';
import * as THREE from 'three';
import { RoundedBoxGeometry } from 'three/examples/jsm/geometries/RoundedBoxGeometry.js';
//import splide.js
import {Splide} from '@splidejs/splide';



// Import GSAP plugins
// import { SplitText } from 'gsap/SplitText';
 import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';

// Register GSAP plugins
// gsap.registerPlugin(SplitText, ScrollTrigger, ScrambleTextPlugin);
 gsap.core.globals("ScrollTrigger", ScrollTrigger);

// Export all modules you want to share
export {
    RoundedBoxGeometry,
    DotLottie,
   gsap,
    THREE,
    ScrollTrigger,
 //   lottie,
    Splide

};